import { Factory } from "@/data/dao/Factory";
import { CookieCache } from "@/data/dao/offline/CookieCache";
import { config } from "@/data/util/Config";

import { translations } from "@/shared/localization/translations";

import { Popup } from "@/app/ui/Popup";

export type SessionExpiredPopupSettings = {
    onConfirm?: { () };
    isAccessRightsChange?: boolean;
};

export class SessionExpiredPopup {
    static show(settings?: SessionExpiredPopupSettings) {
        Popup.show(
            settings?.isAccessRightsChange
                ? translations.auth.sessionExpiredBecauseAccessRightsChangedMessage
                : translations.auth.sessionExpiredMessage,

            () => {
                const cookieStorage = Factory.getInstance<CookieCache>(CookieCache);
                cookieStorage.remove(config.appSessionCookieName);
                if (settings?.onConfirm) {
                    settings.onConfirm();
                }
                location.href = "/";
            },
            undefined,
            undefined,
            "session-expired-popup"
        );
    }
}
